export interface IGetUserAppLanguagePreferencePayload {
	userId: string
}

export enum AvailableAppLanguages {
	ENGLISH = "en",
	HINDI = "hi",
	KANNADA = "kn",
	TELUGU = "te",
}

export enum AvailableAppLanguageNames {
	en = "English",
	hi = "Hindi",
	kn = "Kannada",
	te = "Telugu",
}

export interface IGetUserAppLanguagePreferenceResponse {
	userId: string
	languagePreference: AvailableAppLanguages
	source: string
}
